import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, Td, Tr } from "@chakra-ui/react";
import { FiMenu } from "react-icons/fi";
import { SelectOption } from "newui/components/ui/InputWithLabel/SelectWithLabel";
import { RfxDocumentRow } from "../types/rfx-document.types";
import { DocumentTableRow } from "./DocumentTableRow";

interface SortableDocumentRowProps {
  categoryOptions: SelectOption[];
  doc: RfxDocumentRow;
  hideRevision?: boolean;
  isSelected: boolean;
  onDeleteRequest: (doc: RfxDocumentRow) => void;
  onToggleSelect: (id: number) => void;
  onUpdate: (docId: number, data: { category_id?: number; external_revision?: string }) => Promise<void>;
}

export const SortableDocumentRow = ({
  doc,
  isSelected,
  categoryOptions,
  hideRevision,
  onToggleSelect,
  onUpdate,
  onDeleteRequest,
}: SortableDocumentRowProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: doc.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Tr
      ref={setNodeRef}
      style={style}
      bg={isSelected ? "blue.50" : undefined}
      _hover={{ bg: isSelected ? "blue.100" : "gray.50" }}
      data-testid={`document-row-${doc.id}`}
    >
      <Td width="40px" px={2}>
        <Box
          {...attributes}
          {...listeners}
          cursor="grab"
          color="gray.400"
          _hover={{ color: "gray.600" }}
          data-testid={`drag-handle-${doc.id}`}
        >
          <FiMenu />
        </Box>
      </Td>
      <DocumentTableRow
        doc={doc}
        isSelected={isSelected}
        categoryOptions={categoryOptions}
        hideRevision={hideRevision}
        onToggleSelect={onToggleSelect}
        onUpdate={onUpdate}
        onDeleteRequest={onDeleteRequest}
      />
    </Tr>
  );
};
